import * as React from 'react';
import { Banner, Icon, LabelButton } from '@teamsnap/snap-ui';
import { Modal } from '@teamsnap/teamsnap-ui';

interface Props {
  onClose: () => void;
  isOpen: boolean;
  onComplete: () => void;
}

const DuplicateReg2ConfirmationModal = ({ onClose, isOpen, onComplete }: Props) => {
  const modalStyles = { padding: 20, borderRadius: 4, width: 770, height: 735 };

  return (
    <Modal
      heading={null}
      show={isOpen}
      closeFn={onClose}
      testId="duplicate-registration-2-form--confirmation-modal"
      style={modalStyles}
    >
      <div style={{ height: '100%' }} className="sui-flex sui-flex-col sui-justify-between sui-pt-5">
        <div className="sui-flex sui-flex-col sui-items-center">
          <Icon className="sui-text-green-40" style={{ fontSize: 64 }} filled name="check_circle" size="xl" />

          <div>
            <p className="sui-heading-lg sui-m-3">New registration draft created!</p>
          </div>

          <div className="sui-flex sui-justify-center">
            <div className="sui-max-w-screen-t">
              <Banner
                title="Review and complete your new form"
                caption="Forms with fees will need to have a deposit account selected before registration access can be opened."
                sentiment="warning"
              />
            </div>
          </div>
        </div>

        <div className="sui-flex sui-self-end">
          <LabelButton
            labelText="Go to the new form"
            variantType="primary"
            className="sui-px-3 sui-mr-1 sui-cursor-pointer"
            onClick={onComplete}
            data-testid="duplicate-registration-2-form--complete"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DuplicateReg2ConfirmationModal;
